import { useResource } from '@landsbankinn/l16n';
import { Box, Flex, P } from '@landsbankinn/ui-kit';
import { type AudkenniAppHubData } from '../../../../services/ElectronicIdHubService';
import { Loading } from '../../../Loading';
import { useElectronicIdSubscriber } from '../../hooks/useElectronicIdSubscriber';
import { useSetDebugUrl } from '../../hooks/useSetDebugUrl';
import { res } from './AudkenniAppCode.res';

export function AudkenniAppCode() {
  const { r } = useResource();
  const { data } = useElectronicIdSubscriber<AudkenniAppHubData>('AudkenniApp');
  useSetDebugUrl(
    data?.debugStateId
      ? `/ElectronicId/Mock?id=${data.debugStateId}`
      : undefined,
  );
  const moreDescription = data?.holdingPageSigningMessage;
  const description = data?.code
    ? r(res.loadingAudkenniAppDescription(data.code))
    : '';
  return (
    <AudkenniAppLoading
      description={description}
      moreDescription={moreDescription}
    />
  );
}

export function AudkenniAppLoadingWithCode({ code }: { code: string }) {
  const { r } = useResource();
  const description = code ? r(res.loadingAudkenniAppDescription(code)) : '';

  return (
    <Flex direction="col" mainAxisAlignment="center" height="100%">
      <AudkenniAppLoading description={description} />
    </Flex>
  );
}

function AudkenniAppLoading({
  description,
  moreDescription,
}: {
  description: string;
  moreDescription?: string;
}) {
  const { r } = useResource();
  const title = r(res.loadingAudkenniAppTitle);
  return (
    <>
      <Loading
        title={title}
        description={
          <>
            <Box>
              <P fontVariant="body" paddingBottom="24">
                {description}
              </P>
              {moreDescription && <P fontVariant="body">{moreDescription}</P>}
            </Box>
          </>
        }
      />
    </>
  );
}
